import type { FC } from "react";

import { TableCell } from "@/components/ui/table";
import { cn } from "@/lib/utils";

import type { TableProps } from "./types";

const TableCellLink: FC<TableProps> = ({ children, classes, last = false }) => {
  return (
    <TableCell
      className={cn(
        "px-4 py-[16px] text-[#155FCC] text-xs underline",
        last && "border-b border-gray-200",
        classes
      )}
    >
      {children}
    </TableCell>
  );
};

export default TableCellLink;
